import styles from './PageTopContainer.module.scss'

export const presets = {
  primary: styles.container,
  white: styles.white,
  extraHeight: styles.extraHeight,
  filter: styles.filter,
  grey: styles.grey
}
